<template>
  <v-tooltip :location="location" :max-width="maxWidth">
    <template v-slot:activator="{ props }">
      <v-icon
        :color="iconStyleClass"
        v-bind="props"
        size="x-small"
        class="field-label-tooltip"
        :class="[
          {
            'd-block': dense,
            'text--color-text-placeholder': !iconStyleClass,
            [zIndexClass]: true
          },
          additionalClasses
        ]">
        {{ iconName }}
      </v-icon>
    </template>
    <span><slot></slot></span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    /**
     * @deprecated Without it the icon uses the `text--color-text-placeholder` utility; to be
     * removed together with its call sites in OD-4114.
     */
    iconStyleClass: {
      type: String,
      required: false,
      default: undefined
    },
    iconName: {
      type: String,
      required: false,
      default: 'mdi-help-circle'
    },
    location: {
      type: String,
      required: false,
      default: 'bottom'
    },
    dense: {
      type: Boolean,
      required: false
    },
    maxWidth: {
      type: Number,
      default: 300
    },
    zIndexClass: {
      type: String,
      required: false,
      default: 'z-2'
    },
    additionalClasses: {
      type: Array,
      required: false
    }
  }
};
</script>
